import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/button/Button';
import { HOW_TO_UNDERSTAND } from '../../../constants/shared/CommonConstants';
import { getLegendPanelTitle } from './legendUtils';
import './Legend.scss';
import { generateReactKey } from '../../../utils/shared/commonUtils';

const Legend = ({
    sections,
    customClassName,
    customButtonClassName,
    switchProp,
    legendPanelTitle,
}) => {
    const [isExpanded, setExpand] = useState(false);

    useEffect(() => {
        setExpand(false);
    }, [switchProp]);

    const toggleLegend = () => {
        setExpand(!isExpanded);
    };

    return isExpanded ? (
        <div className={`legend-container-expand ${customClassName}`}>
            <Button
                className={`btn btn-secondary ${customButtonClassName}`}
                text={
                    <>
                        <i className="icon-amplify-close" />
                        Minimize
                    </>
                }
                onClick={toggleLegend}
            />
            <div className="legend-content">
                {sections.map((section, index) => (
                    <Fragment key={generateReactKey(index)}>{section}</Fragment>
                ))}
            </div>
        </div>
    ) : (
        <div className={`legend-container-collapse ${customClassName}`}>
            <Button
                className={`btn btn-secondary ${customButtonClassName}`}
                text={legendPanelTitle}
                onClick={toggleLegend}
            />
        </div>
    );
};

Legend.defaultProps = {
    customClassName: '',
    customButtonClassName: '',
    sections: [],
    switchProp: '',
    legendPanelTitle: getLegendPanelTitle(HOW_TO_UNDERSTAND.ASSESSMENT),
};

Legend.propTypes = {
    customClassName: PropTypes.string,
    customButtonClassName: PropTypes.string,
    sections: PropTypes.array,
    switchProp: PropTypes.string,
    legendPanelTitle: PropTypes.object,
};

export default Legend;
